<ng-container>
    <h4 mat-dialog-title i18n="@@b4a1dca0434ab7259de2be942a0a63394146f376" t="b4a1dca0434ab7259de2be942a0a63394146f376">New Document</h4>
    <h5 i18n="@@258baf43ad34644e8bcb92c8d81d6565809a0a6f" t="258baf43ad34644e8bcb92c8d81d6565809a0a6f">Please complete all fields to maintain accurate data for your organization.</h5>

    <mat-dialog-content [formGroup]="editForm">
        <div fxLayout="row" fxLayoutGap="10px">
            <tsl-form-field fxFlex>
                <tsl-label i18n="@@c903969eedb25df219dedc420b951bf09aa71e52" t="c903969eedb25df219dedc420b951bf09aa71e52">Supplier</tsl-label>
                <input tslInput fullWidth shape="rectangle" required formControlName="supplier" />
            </tsl-form-field>
            <tsl-form-field fxFlex *ngIf="false">
                <tsl-label i18n="@@Address" t="Address">Address</tsl-label>
                <input tslInput fullWidth shape="rectangle" required formControlName="address" />
            </tsl-form-field>
        </div>

        <div fxLayout="row" fxLayoutGap="10px">
            <tsl-form-field fxFlex>
                <tsl-label i18n="@@f61c6867295f3b53d23557021f2f4e0aa1d0b8fc" t="f61c6867295f3b53d23557021f2f4e0aa1d0b8fc">Type</tsl-label>
                <tsl-select formControlName="type" shape="rectangle" required>
                    <tsl-option *ngFor="let item of types" [value]="item.name">
                        {{item.name}} - {{ translateService.get(item.description) }}</tsl-option>
                </tsl-select>
                <tsl-error i18n="@@d258b1d065478feabe75fff88e9d152397ea486e" t="d258b1d065478feabe75fff88e9d152397ea486e">Required</tsl-error>
            </tsl-form-field>
            <tsl-form-field fxFlex>
                <tsl-label i18n="@@cff1428d10d59d14e45edec3c735a27b5482db59" t="cff1428d10d59d14e45edec3c735a27b5482db59">Name</tsl-label>
                <input tslInput fullWidth shape="rectangle" formControlName="name" required />
                <tsl-error i18n="@@45e1f37c18288d0f2131800da2f0d8750c3eae0c" t="45e1f37c18288d0f2131800da2f0d8750c3eae0c">Required</tsl-error>
            </tsl-form-field>
        </div>

        <div fxLayout="row" fxLayoutGap="10px">
            <div fxFlex>
                <mat-checkbox name="noEffectiveDate" formControlName="noEffectiveDate"
                    (change)="onNoCheckedChange($event)">
                    <label class="label" i18n="@@b5985507068940123d5c65eda4cef14a1f886ec8" t="b5985507068940123d5c65eda4cef14a1f886ec8">No Effective Date</label>
                </mat-checkbox>
            </div>
            <tsl-form-field fxFlex>
                <tsl-label i18n="@@f0e56bb50e6ed6836e87d78d254177da229a07d1" t="f0e56bb50e6ed6836e87d78d254177da229a07d1">Effective Date</tsl-label>
                <tsl-datepicker singleSelection required shape="rectangle" formControlName="effectiveDate" [selectYear]="true" [readonly]="true">
                </tsl-datepicker>
                <tsl-error i18n="@@45e1f37c18288d0f2131800da2f0d8750c3eae0c" t="45e1f37c18288d0f2131800da2f0d8750c3eae0c">Required</tsl-error>
            </tsl-form-field>
        </div>

        <div fxLayout="row" fxLayoutGap="10px">
            <div fxFlex>
                <mat-checkbox name="noSignedDate" formControlName="noSignedDate" (change)="onNoCheckedChange($event)">
                    <label class="label" i18n="@@b38fd1f324649c1ed8f4ddab133f165fd1ebf2d1" t="b38fd1f324649c1ed8f4ddab133f165fd1ebf2d1">No Signed Date</label>
                </mat-checkbox>
            </div>
            <tsl-form-field fxFlex>
                <tsl-label i18n="@@f0c0229165e5f2380caa1a3736b304238f1ef166" t="f0c0229165e5f2380caa1a3736b304238f1ef166">Signed Date</tsl-label>
                <tsl-datepicker singleSelection required shape="rectangle" formControlName="signatureDate" [selectYear]="true" [readonly]="true">
                </tsl-datepicker>
                <tsl-error i18n="@@45e1f37c18288d0f2131800da2f0d8750c3eae0c" t="45e1f37c18288d0f2131800da2f0d8750c3eae0c">Required</tsl-error>
            </tsl-form-field>
        </div>

        <div fxLayout="row" fxLayoutGap="10px">
            <div fxFlex>
                <mat-checkbox name="noExpirationDate" formControlName="noExpirationDate"
                    (change)="onNoCheckedChange($event)">
                    <label class="label" i18n="@@262a325d8e2bf186db80badc27c6f1ed357fad3f" t="262a325d8e2bf186db80badc27c6f1ed357fad3f">No Expiration Date</label>
                </mat-checkbox>
            </div>
            <tsl-form-field fxFlex>
                <tsl-label i18n="@@41d055ec9cef3afb116c3118c2244ee66c895fbb" t="41d055ec9cef3afb116c3118c2244ee66c895fbb">Expiration Date</tsl-label>
                <tsl-datepicker singleSelection required shape="rectangle" formControlName="expirationDate" [selectYear]="true" [readonly]="true">
                </tsl-datepicker>
                <tsl-error i18n="@@45e1f37c18288d0f2131800da2f0d8750c3eae0c" t="45e1f37c18288d0f2131800da2f0d8750c3eae0c">Required</tsl-error>
            </tsl-form-field>
        </div>

        <div fxLayout="column">
            <label class="label" i18n="@@66206095b49f7dcd07585d196f356d1fe81e66f1" t="66206095b49f7dcd07585d196f356d1fe81e66f1">File Upload</label>
            <tsl-file-drop [inputText]="translateService.get('choose a file')" [hintText]="translateService.get('Drag and Drop a File or ')" *ngIf="!hasFile" fxFlex #fileDrop accept="*" (fileChange)="onFileAdd($event)">
            </tsl-file-drop>
            <table *ngIf="hasFile" class="tsl-table file-list">
                <tr class="tsl-row" *ngIf="attachment.value">
                    <td class="tsl-cell">
                        {{ attachment.value.fileName || attachment.value.name }}
                        <button (click)="onRemoveAttachment()" tsl-icon-button>
                            <tsl-icon>delete</tsl-icon>
                        </button>
                    </td>
                </tr>
            </table>
        </div>
    </mat-dialog-content>

    <mat-dialog-actions fxLayoutAlign="end center">
        <button tsl-button size="small" color="black" outline (click)="onClose()" i18n="@@d7b35c384aecd25a516200d6921836374613dfe7" t="d7b35c384aecd25a516200d6921836374613dfe7">Cancel</button>
        <button tsl-button size="small" color="blue" filled [disabled]="editForm.invalid"
            (click)="onSave()" i18n="@@52c9a103b812f258bcddc3d90a6e3f46871d25fe" t="52c9a103b812f258bcddc3d90a6e3f46871d25fe">Save</button>
    </mat-dialog-actions>
</ng-container>